import { cn } from '@lair-finance/util'
import { Link } from 'react-router-dom'
import { Logo } from '@/domains/header/ui/Logo.tsx'

export function HeaderContent({ className, app, actions }: { className?: string; app?: React.ReactNode; actions?: React.ReactNode }) {
  return (
    <header
      className={cn('flex items-center justify-between px-5 sm:px-8 bg-greyscale-700 h-[64px] sm:h-[100px] border-b border-greyscale-600', className)}
    >
      {app || (
        <Link to={'/'}>
          <Logo />
        </Link>
      )}
      {actions}
    </header>
  )
}
